// To plug a new external site/system into Mente Sã, add ONE entry here.
// The admin then only pastes the URL (and key) on /admin/integrations and clicks "Conectar".
export interface IntegrationPreset {
  id: string;
  name: string;
  description: string;
  /** Default receiving URL; empty until the receiving system exists. */
  defaultUrl: string;
  needsCompanyId: boolean;
}

export const INTEGRATION_PRESETS: IntegrationPreset[] = [
  {
    id: "bebrave",
    name: "Bebrave",
    description: "Envia agendamentos, vendas, encomendas, colaboradores, clientes e finanças da empresa Mente Sã para o Bebrave.",
    defaultUrl: "",
    needsCompanyId: true,
  },
  {
    id: "custom",
    name: "Outro site / sistema",
    description: "Qualquer sistema que aceite webhooks HTTPS com assinatura HMAC.",
    defaultUrl: "",
    needsCompanyId: false,
  },
];

export const ENTITY_LABELS: Record<string, string> = {
  booking: "Agendamentos",
  booking_service: "Serviços do agendamento",
  order: "Encomendas (loja)",
  order_item: "Itens de encomenda",
  sale_log: "Vendas / registos do PDV",
  staff: "Colaboradores",
  client: "Clientes (sem dados de saúde)",
  staff_payment: "Pagamentos a colaboradores",
  expense: "Despesas",
  service: "Serviços",
  product: "Produtos",
};
